import React from 'react';

import ColorTints from 'components/Toolbar/Shared/ColorTints';
import { ColorSectionProps } from './models';
import styles from './styles.module.scss';

const ColorSection: React.FunctionComponent<ColorSectionProps> = (props) => {
  const { activeColor, colors, title, toggleColor, toggleTooltip, dataTestId = 'colorSection' } = props;

  return (
    <div className={styles.ColorSection} data-testid={dataTestId}>
      <div data-testid={`${dataTestId}-title`}>{title}</div>
      <div className={styles.controls} data-testid={`${dataTestId}-controls`}>
        {colors?.map((color, index) => {
          const name = color?.get('name');

          return (
            <ColorTints
              key={name}
              activeColor={activeColor}
              color={color}
              toggleColor={toggleColor}
              toggleTooltip={toggleTooltip}
              dataTestId={`${dataTestId}-colorTints${index}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ColorSection;
